import _ from 'lodash'
import {
  SET_BANNERS,
  ADD_BANNER_IMAGE_ITEM,
  UPDATE_BANNER_IMAGE_ITEM,
  UPDATE_BANNER_ITEM,
  INIT_BANNERS,
  CREATE_BANNER_ITEM,
} from '../constants/actions'
import config from '../config'

const initState = []

export const initBanner = {
  _id: 'TEMP_ID',
  title: config.getLangText(),
  mainImageId: null,
}

export default (banners = initState, action) => {
  switch (action.type) {
    case INIT_BANNERS:
      if (_.some(banners, { _id: initBanner._id })) {
        return banners
      } else {
        return [...banners, initBanner]
      }
    case SET_BANNERS:
      return action.banners
    case CREATE_BANNER_ITEM:
      return _.map(banners, banner => {
        if (banner._id === initBanner._id) {
          return action.banner
        } else {
          return banner
        }
      })
    case UPDATE_BANNER_ITEM:
      return _.map(banners, banner => {
        if (banner._id === action.banner._id) {
          return {
            ...action.banner,
          }
        } else {
          return banner
        }
      })
    case ADD_BANNER_IMAGE_ITEM:
    case UPDATE_BANNER_IMAGE_ITEM:
      return _.map(banners, banner => {
        if (banner._id === action.bannerID) {
          return {
            ...banner,
            mainImageId: action.mainImageId,
            mainImageLastChecked: action.mainImageLastChecked,
          }
        } else {
          return banner
        }
      })
    default:
      return banners
  }
}



// WEBPACK FOOTER //
// ./src/reducers/banners.js